import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  padding: var(--space-3xl);
  text-align: center;
`;

const ParkDetail = () => {
  return (
    <Container>
      <h1>Park Details</h1>
      <p>Detailed information about a specific park will be shown here.</p>
    </Container>
  );
};

export default ParkDetail;
